import { InspectionGroupBy, IssueGroupBy, QuestionGroupBy } from '@/services/api/resources/analytics/types';
import { t } from '@/ui/i18n/i18n';
import { getMappedRecord } from '@/ui/helpers/uiHelper';

export function questionGroupBy(value: QuestionGroupBy): string {
  const map: Record<QuestionGroupBy, string> = {
    [QuestionGroupBy.Category]: t('common.category'),
    [QuestionGroupBy.Checklist]: t('common.checklist'),
    [QuestionGroupBy.Group]: t('common.group'),
    [QuestionGroupBy.Question]: t('inspections.question'),
    [QuestionGroupBy.EntityItem]: t('common.entity-item'),
    [QuestionGroupBy.Inspector]: t('common.inspector'),
    [QuestionGroupBy.Inspection]: t('common.inspection'),
    [QuestionGroupBy.Section]: t('inspections.section'),
    [QuestionGroupBy.Day]: t('common.day'),
    [QuestionGroupBy.Week]: t('common.week'),
    [QuestionGroupBy.Month]: t('common.month'),
    [QuestionGroupBy.Quarter]: t('common.quarter'),
    [QuestionGroupBy.Year]: t('common.year'),
  };

  return getMappedRecord<QuestionGroupBy>(map, value);
}

export function inspectionGroupBy(value: InspectionGroupBy): string {
  const map: Record<InspectionGroupBy, string> = {
    [InspectionGroupBy.Checklist]: t('common.checklist'),
    [InspectionGroupBy.EntityItem]: t('common.entity-item'),
    [InspectionGroupBy.Category]: t('common.category'),
    [InspectionGroupBy.Group]: t('common.group'),
    [InspectionGroupBy.Assignee]: t('common.assignee'),
    [InspectionGroupBy.Day]: t('common.day'),
    [InspectionGroupBy.Week]: t('common.week'),
    [InspectionGroupBy.Month]: t('common.month'),
    [InspectionGroupBy.Quarter]: t('common.quarter'),
    [InspectionGroupBy.Year]: t('common.year'),
  };

  return getMappedRecord<InspectionGroupBy>(map, value);
}

export function issueGroupBy(value: IssueGroupBy): string {
  const map: Record<IssueGroupBy, string> = {
    [IssueGroupBy.Creator]: t('common.creator'),
    [IssueGroupBy.Assignee]: t('common.assignee'),
    [IssueGroupBy.Resolver]: t('common.resolver'),
    [IssueGroupBy.Question]: t('inspections.question'),
    [IssueGroupBy.EntityItem]: t('common.entity-item'),
    [IssueGroupBy.Group]: t('common.group'),
    [IssueGroupBy.Category]: t('common.category'),
    [IssueGroupBy.Checklist]: t('common.checklist'),
    [IssueGroupBy.Inspection]: t('common.inspection'),
    [IssueGroupBy.Section]: t('inspections.section'),
    [IssueGroupBy.Type]: t('issues.group.type'),
    [IssueGroupBy.Sensor]: t('common.sensor'),
    [IssueGroupBy.Priority]: t('common.priority'),
    [IssueGroupBy.Day]: t('common.day'),
    [IssueGroupBy.Week]: t('common.week'),
    [IssueGroupBy.Month]: t('common.month'),
    [IssueGroupBy.Quarter]: t('common.quarter'),
    [IssueGroupBy.Year]: t('common.year'),
  };

  return getMappedRecord<IssueGroupBy>(map, value);
}
